import classNames from "classnames";
import React, { useState } from "react";
import { ListItem } from "../list";

export const CookieTextListItem = ({ cookieKey, label }: { cookieKey: string; label?: string }) => {
	const [textValue, setTextValue] = useState(eXpress.platform.cookies.getCookie(cookieKey));

	const cssClasses = classNames("cookie-list__item");

	return (
		<ListItem className={cssClasses} style={{ display: "flex", flexDirection: "column" }}>
			<div style={{ width: "100%" }}>{label}</div>
			<div>
				<input
					type="text"
					value={textValue || ""}
					style={{ width: "100%" }}
					onChange={(e) => {
						const newValue = e.target.value;

						eXpress.platform.cookies.setCookie(cookieKey, newValue, {
							path: "/",
						});
						setTextValue(newValue);
					}}
				/>
			</div>
		</ListItem>
	);
};
